import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Footer.css';
import QuoteModal from './QuoteModal';

import logo from '../assets/prelogo1.jpeg';

// Contact Icons
import locationIcon from '../assets/map.png';
import phoneIcon from '../assets/call.webp';
import whatsappIcon from '../assets/watsapp.png';
import emailIcon from '../assets/gmail.png';

// Social Media Icons
import facebookIcon from '../assets/fb.png';
import instagramIcon from '../assets/insta.png';
import linkedinIcon from '../assets/link.png';


const Footer = () => {

  const currentYear = new Date().getFullYear();

  const navigate = useNavigate();

  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);


  /* ==========================================
     QUOTE MODAL
  ========================================== */

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };


  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };


  /* ==========================================
     NAVIGATION
  ========================================== */

  const handleNavigation = (path, sectionId) => {

    if (path === '/' && sectionId) {

      navigate('/');

      setTimeout(() => {

        const element = document.getElementById(sectionId);

        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }

      }, 100);

    } else {

      navigate(path);

    }

  };


  /* ==========================================
     QUICK LINKS
  ========================================== */

  const quickLinks = [

    {
      name: 'Home',
      path: '/',
      section: 'home'
    },

    {
      name: 'About Us',
      path: '/about'
    },

    {
      name: 'Our Products',
      path: '/products'
    },

    {
      name: 'BYOB Program',
      path: '/',
      section: 'byob-program'
    },

    {
      name: 'Why Partner With Us',
      path: '/',
      section: 'why-partner'
    },

    {
      name: 'Contact Us',
      path: '/contact'
    }

  ];


  /* ==========================================
     PRODUCTS
  ========================================== */

  const ourProducts = [

    {
      name: 'QuickFit ANC R',
      path: '/products'
    }

  ];


  /* ==========================================
     SUPPORT LINKS
  ========================================== */

  const supportLinks = [

    {
      name: 'Partner Registration',
      action: 'quote'
    },

    {
      name: 'Bulk Inquiry',
      action: 'quote'
    },

    {
      name: 'Clinic Support',
      action: 'quote'
    },

    {
      name: 'Distributor Enquiry',
      action: 'quote'
    },

    {
      name: 'Service Request',
      action: 'quote'
    },

    {
      name: 'FAQs',
      action: 'contact'
    }

  ];


  /* ==========================================
     SOCIAL LINKS
  ========================================== */

  const socialLinks = [

    {
      name: 'Facebook',
      icon: facebookIcon,
      link: 'https://www.facebook.com/share/1DhfVX35Zi/'
    },

    {
      name: 'Instagram',
      icon: instagramIcon,
      link: 'https://www.instagram.com/preferred_audiology_pvt_ltd?stkn=eGsxa2E4aWVyemJo'
    },

    {
      name: 'LinkedIn',
      icon: linkedinIcon,
      link: 'https://www.linkedin.com/company/preferred-audiology-pvt-ltd/'
    }

  ];


  return (

    <>

      <footer className="footer">

        <div className="footer-container">


          {/* ==================================
              MAIN FOOTER
          ================================== */}

          <div className="footer-grid">


            {/* ==================================
                COMPANY INFORMATION
            ================================== */}

            <div className="footer-column footer-company-column">


              {/* LOGO */}

              <div className="footer-logo">

                <Link
                  to="/"
                  aria-label="Preferred Audiology Home"
                >

                  <img
                    src={logo}
                    alt="Preferred Audiology Logo"
                    className="footer-logo-img"
                  />

                </Link>

              </div>


              {/* MAIN COMPANY TAGLINE */}

              <div className="footer-brand-tagline">

                <span className="footer-brand-tagline-main">
                  HEAR MORE,
                </span>

                <span className="footer-brand-tagline-accent">
                  SPEND LESS
                </span>

              </div>


              {/* COMPANY DESCRIPTION */}

              <p className="footer-description">

                India's most innovative hearing aid manufacturer and distributor.
                We help clinics, distributors, and retail chains build their own brand.

              </p>


              {/* BRAND TAGS */}

              <div className="footer-taglines-wrapper">

                <div className="footer-tagline">

                  <span className="footer-tagline-text">
                    #BuildYourOwnBrand
                  </span>

                </div>


                <div className="footer-tagline">

                  <span className="footer-tagline-text">
                    #RealMrp
                  </span>

                </div>

              </div>


            </div>


            {/* ==================================
                QUICK LINKS
            ================================== */}

            <div className="footer-column">

              <h3 className="footer-title">
                Quick Links
              </h3>


              <ul className="footer-links">

                {quickLinks.map((link, index) => (

                  <li key={index}>

                    <button
                      type="button"
                      onClick={() =>
                        handleNavigation(
                          link.path,
                          link.section
                        )
                      }
                      className="footer-link"
                    >

                      <span className="footer-link-icon">
                        →
                      </span>

                      {link.name}

                    </button>

                  </li>

                ))}

              </ul>

            </div>


            {/* ==================================
                OUR PRODUCTS
            ================================== */}

            <div className="footer-column">

              <h3 className="footer-title">
                Our Products
              </h3>


              <ul className="footer-links">

                {ourProducts.map((product, index) => (

                  <li key={index}>

                    <button
                      type="button"
                      onClick={() =>
                        handleNavigation(
                          product.path,
                          product.section
                        )
                      }
                      className="footer-link"
                    >

                      <span className="footer-link-icon">
                        →
                      </span>

                      {product.name}

                    </button>

                  </li>

                ))}

              </ul>

            </div>


            {/* ==================================
                SUPPORT
            ================================== */}

            <div className="footer-column">

              <h3 className="footer-title">
                Support
              </h3>


              <ul className="footer-links">

                {supportLinks.map((support, index) => (

                  <li key={index}>

                    {support.action === 'quote' ? (

                      <button
                        type="button"
                        onClick={openQuoteModal}
                        className="footer-link"
                      >

                        <span className="footer-link-icon">
                          →
                        </span>

                        {support.name}

                      </button>

                    ) : (

                      <button
                        type="button"
                        onClick={() => navigate('/contact')}
                        className="footer-link"
                      >

                        <span className="footer-link-icon">
                          →
                        </span>

                        {support.name}

                      </button>

                    )}

                  </li>

                ))}

              </ul>

            </div>


            {/* ==================================
                CONTACT
            ================================== */}

            <div className="footer-column footer-contact-column">

              <h3 className="footer-title">
                Contact Us
              </h3>


              <div className="footer-contact">


                {/* ADDRESS */}

                <div className="footer-contact-item">

                  <div className="footer-contact-icon-wrapper">

                    <img
                      src={locationIcon}
                      alt=""
                      className="footer-contact-icon-img"
                    />

                  </div>


                  <div className="footer-contact-text">

                    <strong>
                      Office Address
                    </strong>

                    <p>

                      Preferred Audiology Pvt. Ltd.

                      <br />

                      Ecospace Business Towers,
                      Tower 5A, Office no. 508

                      <br />

                      New Town, Kolkata - 700160

                    </p>

                  </div>

                </div>


                {/* PHONE */}

                <div className="footer-contact-item">

                  <div className="footer-contact-icon-wrapper">

                    <img
                      src={phoneIcon}
                      alt=""
                      className="footer-contact-icon-img"
                    />

                  </div>


                  <div className="footer-contact-text">

                    <strong>
                      Phone
                    </strong>

                    <p>

                      <a href="tel:03323240508">
                        033-23240508
                      </a>

                    </p>

                  </div>

                </div>


                {/* WHATSAPP */}

                <div className="footer-contact-item">

                  <div className="footer-contact-icon-wrapper">

                    <img
                      src={whatsappIcon}
                      alt=""
                      className="footer-contact-icon-img"
                    />

                  </div>


                  <div className="footer-contact-text">

                    <strong>
                      WhatsApp
                    </strong>

                    <p>

                      <a
                        href="https://wa.me/919748691530"
                        target="_blank"
                        rel="noopener noreferrer"
                      >

                        +91 9748691530

                      </a>

                    </p>

                  </div>

                </div>


                {/* EMAIL */}

                <div className="footer-contact-item">

                  <div className="footer-contact-icon-wrapper">

                    <img
                      src={emailIcon}
                      alt=""
                      className="footer-contact-icon-img"
                    />

                  </div>


                  <div className="footer-contact-text">

                    <strong>
                      Email
                    </strong>

                    <p>

                      <a href="mailto:info@paplhear.com">

                        info@paplhear.com

                      </a>

                    </p>

                  </div>

                </div>

              </div>


              {/* ==================================
                  SOCIAL MEDIA
              ================================== */}

              <div className="footer-social">

                <h4 className="footer-social-title">
                  Follow Us
                </h4>


                <div className="footer-social-icons">

                  {socialLinks.map((social, index) => (

                    <a
                      key={index}
                      href={social.link}
                      className="footer-social-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                    >

                      <img
                        src={social.icon}
                        alt=""
                        className="footer-social-icon"
                      />

                    </a>

                  ))}

                </div>

              </div>


            </div>

          </div>


          {/* ==================================
              BUSINESS HOURS
          ================================== */}

          <div className="footer-hours">

            <div
              className="footer-hours-icon"
              aria-hidden="true"
            >

              <i className="fa-regular fa-clock"></i>

            </div>


            <div className="footer-hours-text">

              <strong>
                Business Hours:
              </strong>

              {' '}

              Monday - Friday | 10:00 AM - 6:00 PM

            </div>


            <div className="footer-hours-badge">

              Pan-India Support

            </div>

          </div>


          {/* ==================================
              BOTTOM BAR
          ================================== */}

          <div className="footer-bottom">


            <div className="footer-bottom-content">

              <p>

                &copy; {currentYear} Preferred Audiology Pvt. Ltd.
                All rights reserved.

              </p>


              <div className="footer-bottom-links">

                <button
                  type="button"
                  onClick={() => navigate('/privacy-policy')}
                  className="footer-bottom-link"
                >

                  Privacy Policy

                </button>


                <span className="footer-bottom-divider">
                  |
                </span>


                <button
                  type="button"
                  onClick={() => navigate('/terms-conditions')}
                  className="footer-bottom-link"
                >

                  Warranty Policy

                </button>

              </div>

            </div>


            <div className="footer-bottom-made">

              Made with{' '}

              <span
                className="footer-heart"
                aria-hidden="true"
              >
                ❤
              </span>

              {' '}in India

            </div>


          </div>


        </div>

      </footer>


      {/* ==================================
          QUOTE MODAL
      ================================== */}

      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={closeQuoteModal}
      />

    </>

  );

};


export default Footer;